import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Accordion = ({ items, allowMultiple = false, defaultOpenIds = [], className, }) => {
    const initOpen = React.useMemo(() => items.reduce((acc, item) => {
        const shouldOpen = item.defaultOpen || defaultOpenIds.includes(item.id);
        return shouldOpen && !acc.includes(item.id) ? [...acc, item.id] : acc;
    }, []), [defaultOpenIds, items]);
    const [openIds, setOpenIds] = React.useState(initOpen);
    const toggle = (id) => {
        setOpenIds(prev => {
            const isOpen = prev.includes(id);
            if (isOpen)
                return prev.filter(x => x !== id);
            return allowMultiple ? [...prev, id] : [id];
        });
    };
    return (_jsx("div", { className: className, children: items.map(item => {
            const isOpen = openIds.includes(item.id);
            return (_jsxs("div", { className: "border-bottom", children: [_jsxs("button", { type: "button", className: "w-100 text-start py-3 border-0 bg-transparent d-flex justify-content-between align-items-center", onClick: () => toggle(item.id), "aria-expanded": isOpen, children: [_jsx("span", { className: "fw-medium", children: item.title }), _jsx("span", { "aria-hidden": true, className: `ms-3 d-inline-block accordion-chevron${isOpen ? ' open' : ''}`, children: "\u25B8" })] }), _jsx("div", { className: `accordion-body${isOpen ? ' open' : ''}`, children: _jsx("div", { children: _jsx("div", { className: "pb-3 text-muted small", children: item.content }) }) })] }, item.id));
        }) }));
};
export default Accordion;
